export enum Lang {
  LV = "lv",
  EN = "en",
}
export type PageContext = {
  lang: Lang
}
